<template>
  <div>
    <loginPage
      v-if="pageName === 'loginPage'"
      @register="register"
      @loginPost="loginPost"
      @OnGoogleAuthSuccess="OnGoogleAuthSuccess"
    ></loginPage>
    <addTask
      v-else-if="pageName === 'addTaskPage'"
      @homePage="homePage"
      :addTaskCategoryId="addTaskCategoryId"
      @addTask="addTask"
    ></addTask>
    <registerPage
      v-else-if="pageName === 'registerPage'"
      @login="login"
      @registerPost="registerPost"
    ></registerPage>
    <listColumn
      v-else-if="pageName==='homePage'"
      :columns="columns"
      @logout="logout"
      :organizationData="organizationId"
      @organizationFinder="organizationFinder"
      @createTaskPage="createTaskPage"
      @deleteTask="deleteTask"
      @createEditPage="createEditPage"
      @deleteColumn="deleteColumn"
      @addColumnPage="addColumnPage"
      @addOrganizationPage="addOrganizationPage"
      @deleteOrganization="deleteOrganization"
      @addFriend="addFriend"
      :organizationName="organizationName"
    ></listColumn>
    <EditTask
      v-else-if="pageName==='editTask'"
      :columns="columns"
      @homePage="homePage"
      :taskData="taskData"
      @editTask="editTask"
    ></EditTask>
    <addColumnPage v-else-if="pageName ==='addColumn'" @homePage="homePage" @addColumn="addColumn"></addColumnPage>
    <addOrganizationPage
      v-else-if="pageName === 'addOrganizationPage' "
      @addOrganization="addOrganization"
      @homePage="homePage"
    ></addOrganizationPage>
  </div>
</template>
<script>
import loginPage from "./components/LogIn";
import addTask from "./components/AddTask";
import registerPage from "./components/RegisterPage";
import listColumn from "./components/ListColumn";
import EditTask from "./components/EditTask";
import addColumnPage from "./components/addColumn";
import addOrganizationPage from "./components/addOrganization";
export default {
  name: "AppVue",
  components: {
    loginPage,
    addTask,
    registerPage,
    listColumn,
    EditTask,
    addColumnPage,
    addOrganizationPage
  },
  data() {
    return {
      pageName: "loginPage",
      columns: [],
      organizationId: [],
      addTaskCategoryId: "",
      taskData: "",
      host: `https://sleepy-badlands-56742.herokuapp.com`,
      organizationName: ""
    };
  },
  methods: {
    OnGoogleAuthSuccess(payload) {
      let { idToken } = payload;
      console.log(payload);
      axios({
        method: `post`,
        url: this.host + `/google-login`,
        data: {
          idToken
        }
      })
        .then(data => {
          console.log(data);
          localStorage.token = data.data.token;
          localStorage.userEmail = data.data.email;

          this.pageName = "homePage";
          console.log(data.data.email);
          this.userorganization();
        })
        .catch(err => {
          console.log(err);
        });
    },
    register() {
      this.pageName = "registerPage";
    },
    homePage() {
      this.pageName = "homePage";
    },
    login() {
      this.pageName = "loginPage";
    },
    logout() {
      localStorage.clear();
      this.pageName = "loginPage";
      this.organizationId = [];
      this.columns = [];
      this.organizationName = null;
    },
    loginPost(payload) {
      let email = payload.email;
      let password = payload.password;
      axios({
        method: `post`,
        url: this.host+`/login`,
        data: {
          email,
          password
        }
      })
        .then(data => {
          localStorage.token = data.data.token;
          localStorage.userEmail = data.data.email;

          this.pageName = "homePage";
          console.log(data.data.email);
          this.userorganization();
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    addFriend(payload) {
      let { email } = payload;
      let { organizationId, token } = localStorage;
      console.log(email, organizationId);
      axios({
        method: `post`,
        url: this.host + `/organization/${organizationId}/invite-friend`,
        data: {
          email
        },
        headers: {
          token
        }
      })
        .then(data => {
          console.log(data);
          Swal.fire({
            icon: "success",
            title: "Nice",
            text: `Sukses Add Friend`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    addOrganizationPage() {
      this.pageName = "addOrganizationPage";
    },
    addOrganization(payload) {
      let { name } = payload;
      let token = localStorage.token;
      console.log(payload);
      axios({
        method: `post`,
        url: this.host + `/organization`,
        data: {
          name
        },
        headers: {
          token
        }
      })
        .then(data => {
          console.log(data);
          this.pageName = "homePage";
          this.userorganization();
          Swal.fire({
            icon: "success",
            title: "Nice eh",
            text: `Sukses Add Organization`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    deleteOrganization() {
      let token = localStorage.token;
      let organizationId = localStorage.organizationId;
      console.log(organizationId);
      axios({
        method: `delete`,
        url: this.host + `/organization/${organizationId}`,
        headers: {
          token
        }
      })
        .then(data => {
          console.log(data);
          this.pageName = "homePage";
          this.userorganization();
          this.columns = [];
          this.organizationName='';
          
          Swal.fire({
            icon: "success",
            title: "Nice eh",
            text: `Berhasil delete Organization`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    addColumnPage() {
      console.log(localStorage.organizationId);
      this.pageName = "addColumn";
    },
    addColumn(payload) {
      let { id, title } = payload;
      let token = localStorage.token;
      axios({
        method: `post`,
        url: this.host + `/column/${id}`,
        data: {
          title
        },
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
        .then(data => {
          console.log(data);
          let tekan = {
            id: localStorage.organizationId
          };
          this.organizationFinder(tekan);
          this.pageName = "homePage";
          Swal.fire({
            icon: "success",
            title: "mann..",
            text: `Berhasil Buat Column`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    deleteColumn(payload) {
      let { id } = payload;
      let token = localStorage.token;
      axios({
        method: `delete`,
        url: this.host + `/column/${id}`,
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
        .then(data => {
          console.log(data);
          let tekan = {
            id: localStorage.organizationId
          };
          this.organizationFinder(tekan);
          this.pageName = "homePage";
          Swal.fire({
            icon: "success",
            title: "Yess!",
            text: `Berhasil Delete Column`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    createTaskPage(params) {
      let { id } = params;

      this.addTaskCategoryId = id;
      this.pageName = "addTaskPage";
    },
    addTask(payload) {
      let { id, title, description } = payload;
      let token = localStorage.token;
      axios({
        method: `post`,
        url: this.host+`/task/${id}`,
        data: {
          title,
          description
        },
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
        .then(data => {
          console.log(data);
          let tekan = {
            id: localStorage.organizationId
          };
          this.organizationFinder(tekan);
          this.pageName = "homePage";
          Swal.fire({
            icon: "success",
            title: "You are here for a lifetime",
            text: `Berhasil Add Task`
          });
          // console.log(localStorage.organizationId,`add task`);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
    },
    createEditPage(payload) {
      let { id } = payload;
      let token = localStorage.token;
      console.log(id, `create Edit Page`);
      axios({
        method: `get`,
        url: this.host+`/task/${id}`,
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
        .then(data => {
          this.pageName = "editTask";
          this.taskData = data.data;
          console.log(data.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    editTask(payload) {
      let { title, description, categoryId, id } = payload;
      let token = localStorage.token;
      axios({
        method: `put`,
        url: this.host+`/task/${id}`,
        data: {
          title,
          description,
          categoryId
        },
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
        .then(data => {
          console.log(data);
          let tekan = {
            id: localStorage.organizationId
          };
          this.organizationFinder(tekan);
          this.pageName = "homePage";
          Swal.fire({
            icon: "success",
            title: "Nothing Matters",
            text: `Berhasil Edit Task`
          });
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`
          });
        });
      // console.log(payload, `appvue`);
    },
    deleteTask(payload) {
      let { id } = payload;
      let token = localStorage.token;
      axios({
        method: `delete`,
        url: this.host+`/task/${id}`,
        headers: {
          token,
          id: localStorage.organizationId
        }
      })
      .then(data => {
        console.log(data);
        let tekan = {
          id: localStorage.organizationId
        };
        this.organizationFinder(tekan);
        this.pageName = "homePage";
        Swal.fire({
            icon: "success",
            title: "This is my life now",
            text: `Berhasil delete task`,
          });
      })
      .catch(err=>{
        console.log(err)
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`,
          });
      })
      // console.log(id, `dari app.vue`);

    },
    registerPost(payload) {
      let email = payload.email;
      let password = payload.password;
      let rePassword = payload.rePassword;
      let name = payload.name;
      axios({
        method: "post",
        url: this.host+`/register`,
        data: {
          email,
          password,
          rePassword,
          name
        }
      })
        .then(data => {
          this.pageName = "loginPage";
          console.log(data);
          Swal.fire({
            icon: "success",
            title: "Send Help",
            text: `Berhasil Register Email`,
          });
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.errMsg}`,
          });
        });
    },
    userorganization() {
      let token = localStorage.token;

      axios({
        method: `get`,
        url: this.host+`/userorganization`,
        headers: {
          token
        }
      })
        .then(data => {
          // this.organizationId = [];
          let result = [];
          let olahanData = data.data.userorganizations;
          for (let i = 0; i < olahanData.length; i++) {
            result.push(olahanData[i]);
          }
          this.organizationId = result;
          console.log(this.organizationId);
        })
        .catch(err => {
          console.log(err);
        });
    },
    organizationFinder(params) {
      console.log(params);
      let { id } = params;
      let token = localStorage.token;
      localStorage.organizationId = id;
      console.log(`keteken di organization Finder`, id);
      axios({
        method: `get`,
        url: this.host+`/organization/${id}/detail`,
        headers: {
          token
        }
      })
        .then(data => {
          // this.columns=[];
          localStorage.organizationName = data.data.name;
          let namaOrganization = data.data.name;
          this.organizationName = namaOrganization;
          let result = [];
          let dataColumn = data.data.columns;
          for (let i = 0; i < dataColumn.length; i++) {
            result.push(dataColumn[i]);
          }
          this.columns = result;

          console.log(this.columns, `dari organization Finder`);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created: function() {
    if (localStorage.token) {
      this.pageName = "homePage";
      this.userorganization();
    } else {
      this.pageName = "loginPage";
    }
  }
};
</script>

<style scoped>
</style>